import React, { createContext } from 'react'

interface AppContextInterface {
    walletAddress: string
    handleContextWallet: (wallet: string) => void
}

const UserContext = createContext<AppContextInterface | null>(null)

export default UserContext
